import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprice-sass-copyright',
  templateUrl: './enterprice-sass-copyright.component.html',
  styleUrls: ['./enterprice-sass-copyright.component.scss']
})
export class EnterpriceSassCopyrightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
